import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoSwitchLabelPosition } from '@po-ui/ng-components';
import { defaultExpedicaoRomaneioItemPedidoDto, ExpedicaoRomaneioItemPedidoDto } from '../../romaneio/interface/romaneio';
import { RomaneioService } from '../../romaneio/service/romaneio.service';
import { ZprLookupService } from 'src/app/service/zpr-lookup.service';
import { Zpr } from 'src/app/interface/zpr';
import { environment } from 'src/environments/environment';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-altera-pedido-expedicao',
  templateUrl: './altera-pedido-expedicao.component.html',
  styleUrls: ['./altera-pedido-expedicao.component.css']
})
export class AlteraPedidoExpedicaoComponent implements OnInit {

  etiquetalote: string = '';
  novoPedido: string = '';
  etiquetaExpedicaoPedido: ExpedicaoRomaneioItemPedidoDto;
  nroContainer: number = 0;
  motivoTransferencia: string = '';
  romaneioConfirmacao98: string = '';
  transferencia98EmAndamento: boolean = false;
  romaneioConfirmacaoPedido: string = '';
  loteConfirmacaoPedido: string = '';
  transferenciaPedidoEmAndamento: boolean = false;

  impressora: string = '';
  nCopias: string = '1';

  labelTransferencia: string = '';
  disableTransferencia: boolean = true;

  zprAdvancedFilters: Array<PoDynamicFormField>;
  zprColumnsFilters: Array<PoLookupColumn>;
  zprFieldFormaterFilters: (value: Zpr) => string;

  URselecionada: number = 0;

  urlApiProtheus: string = environment.urlApiProtheus;

  labelPosition: PoSwitchLabelPosition = PoSwitchLabelPosition.Left;

  lInstrucao: boolean = false;

  constructor(
    private romaneioService: RomaneioService,
    private router: Router,
    private poNotificationService: PoNotificationService,
    public zprService: ZprLookupService,
  ) {

    this.zprService.grupo = 'PRINTLIST';
    this.etiquetaExpedicaoPedido = defaultExpedicaoRomaneioItemPedidoDto();

    this.zprAdvancedFilters      = this.zprService.getAdvancedFilter();
    this.zprColumnsFilters       = this.zprService.getColumnsFilterCompleto();
    this.zprFieldFormaterFilters = this.zprService.getFieldFormater;
  }

  ngOnInit(): void {

  }


  @ViewChild('transferirLoteModal', { static: true }) transferirLoteModal!: PoModalComponent;
  @ViewChild('transferir98Modal', { static: true }) transferir98Modal!: PoModalComponent;
  @ViewChild('alterarPedidoModal', { static: true }) alterarPedidoModal!: PoModalComponent;
  @ViewChild('alterarContainerModal', {static: true}) alterarContainerModal!: PoModalComponent;
  @ViewChild('alterarURModal', {static: true}) alterarURModal!: PoModalComponent;
  @ViewChild('impressaoEtiquetaModal', {static: true}) impressaoEtiquetaModal!: PoModalComponent;

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Expedição', action: this.goTo.bind(this) },
      { label: 'Alterar Pedido por Lote' }
    ]
  };

  goTo(): void {
    this.router.navigateByUrl('');
  }

  biparEtiqueta(): void {
    if (this.etiquetalote != '') {
      this.romaneioService.consultaTransferenciaExpedicao(this.etiquetalote).subscribe((ret) => {
        this.etiquetaExpedicaoPedido = ret;
        if (this.etiquetaExpedicaoPedido.CZ02STATUS == 'P') {
          this.labelTransferencia = 'Transferir lote do armazém ET/ER para armazém OT/OR'
          this.disableTransferencia = false;
        } else if (this.etiquetaExpedicaoPedido.CZ02STATUS == 'O') {
          this.labelTransferencia = 'Transferir lote do armazém OT/OR para armazém ET/ER'
          this.disableTransferencia = false;
        } else {
          this.labelTransferencia = ''
          this.disableTransferencia = true;
        }
      });
      this.etiquetalote = '';
    }
  }

  transfereEstoque(): void {
    this.zprService.grupo = 'MOTTRANSF';
    if (this.etiquetaExpedicaoPedido.CZ02STATUS != 'O') {
      this.transferirLoteModal.open();
    } else {
      this.romaneioService.transferenciaArmazemLote(this.etiquetaExpedicaoPedido.CZ02COD, this.motivoTransferencia).subscribe((res) => {
        this.poNotificationService.success("Lote transferido com sucesso!");
        this.novoPedido = '';
        this.motivoTransferencia = '';
        this.etiquetaExpedicaoPedido = defaultExpedicaoRomaneioItemPedidoDto();
      });
    }
  }

  transferirPara98(): void {
    if (this.etiquetaExpedicaoPedido.CZ02COD === '' || this.transferencia98EmAndamento) {
      return;
    }

    this.transferencia98EmAndamento = true;
    this.romaneioService.transferenciaArmazem98(this.etiquetaExpedicaoPedido.CZ02COD)
      .pipe(finalize(() => this.transferencia98EmAndamento = false))
      .subscribe({
        next: (res) => {
          if (res?.CONFIRMACAO === true) {
            this.romaneioConfirmacao98 = res.CROMANEIO || '';
            this.transferir98Modal.open();
            return;
          }
          this.finalizaTransferencia98();
        }
      });
  }

  transferir98ModalConfirmar(): void {
    if (this.transferencia98EmAndamento) {
      return;
    }

    this.transferencia98EmAndamento = true;
    this.romaneioService.transferenciaArmazem98(this.etiquetaExpedicaoPedido.CZ02COD, true)
      .pipe(finalize(() => this.transferencia98EmAndamento = false))
      .subscribe({
        next: () => {
          this.transferir98Modal.close();
          this.finalizaTransferencia98();
        },
        error: () => {
          this.transferir98Modal.close();
        }
      });
  }

  transferir98ModalCancelar(): void {
    this.transferir98Modal.close();
    this.romaneioConfirmacao98 = '';
  }

  private finalizaTransferencia98(): void {
    this.poNotificationService.success(`Lote ${this.etiquetaExpedicaoPedido.CZ02LOTE} transferido para o Armazém 98.`);
    this.novoPedido = '';
    this.motivoTransferencia = '';
    this.romaneioConfirmacao98 = '';
    this.etiquetaExpedicaoPedido = defaultExpedicaoRomaneioItemPedidoDto();
  }

  alterarPedido(): void {
    if (this.novoPedido !== '' && !this.transferenciaPedidoEmAndamento) {
      this.executaAlteracaoPedido();
    }
  }

  alterarPedidoModalConfirmar(): void {
    if (!this.transferenciaPedidoEmAndamento) {
      this.executaAlteracaoPedido('S');
    }
  }

  alterarPedidoModalCancelar(): void {
    this.alterarPedidoModal.close();
    this.romaneioConfirmacaoPedido = '';
    this.loteConfirmacaoPedido = '';
  }

  executaAlteracaoPedido(confirmar: string = ''): void {
    this.transferenciaPedidoEmAndamento = true;
    this.romaneioService.transferenciaPedido(this.etiquetaExpedicaoPedido.CZ02COD, this.novoPedido, confirmar).subscribe({
      next: (ret) => {
        this.transferenciaPedidoEmAndamento = false;

        if (ret.CONFIRMACAO === true) {
          this.romaneioConfirmacaoPedido = ret.CROMANEIO || '';
          this.loteConfirmacaoPedido = ret.CLOTE || this.etiquetaExpedicaoPedido.CZ02LOTE;
          this.alterarPedidoModal.open();
        } else {
          this.alterarPedidoModal.close();
          this.poNotificationService.success('Pedido alterado com sucesso!');
          this.novoPedido = '';
          this.romaneioConfirmacaoPedido = '';
          this.loteConfirmacaoPedido = '';
          this.etiquetaExpedicaoPedido = defaultExpedicaoRomaneioItemPedidoDto();
        }
      },
      error: () => {
        this.transferenciaPedidoEmAndamento = false;

        if (confirmar === 'S') {
          this.alterarPedidoModal.close();
        }
      }
    });
  }

  openModalImpressora(): void {
    this.zprService.grupo = 'PRINTLIST';
    this.impressaoEtiquetaModal.open();
  }

  public readonly transferirLoteAction: PoModalAction = {
    action: () => {
      if (this.motivoTransferencia != '') {
        this.romaneioService.transferenciaArmazemLote(this.etiquetaExpedicaoPedido.CZ02COD, this.motivoTransferencia).subscribe((res) => {
          this.poNotificationService.success("Lote transferido com sucesso!");
          this.novoPedido = '';
          this.transferirLoteModal.close()
          this.motivoTransferencia = '';
          this.etiquetaExpedicaoPedido = defaultExpedicaoRomaneioItemPedidoDto();
        });
      } else {
        this.poNotificationService.warning({
          message: 'Por favor, informe um motivo para a transferência',
          duration: 5000
        });
      }
    },
    label: 'Transferir',
  };

  public readonly gerarEtiquetaClienteAction: PoModalAction = {
    action: () => {
      this.impressaoEtiquetaModal.close();
      this.romaneioService.getEtiquetaCliente(this.etiquetaExpedicaoPedido.CZ02LOTE, this.impressora, this.nCopias, this.lInstrucao ? 'S': 'N').subscribe((res) => {
        if (this.impressora == "PDF") {
          var file = new Blob([res], {type: 'application/pdf'});
          var fileName = `ETIQUETA_CLIENTE_${this.etiquetaExpedicaoPedido.CZ02LOTE}_${new Date().toLocaleString()}.pdf`;
          var a = document.createElement("a");
          document.body.appendChild(a);

          var fileURL = window.URL.createObjectURL(file);
          a.href = fileURL;
          a.download = fileName;
          a.click();
        } else {
          this.poNotificationService.success("Etiqueta enviada para impressão!")
        }
      });
    },
    label: 'Imprimir',
  };

  alterarContainer(): void {
    this.nroContainer = this.etiquetaExpedicaoPedido.NZ02CTNR;
    this.alterarContainerModal.open();
  }

  alterarUR(): void {
    this.URselecionada = 0;
    this.URselecionada = this.etiquetaExpedicaoPedido.NZ05RECNO
    this.alterarURModal.open();
  }

  public readonly alterarContainerAction: PoModalAction = {
    action: () => {

      this.alterarContainerModal.close();
      this.romaneioService.alterarContainer(this.etiquetaExpedicaoPedido.CZ02COD, this.nroContainer).subscribe((res) => {
        this.poNotificationService.success("Container alterado com sucesso!");
        this.etiquetalote = this.etiquetaExpedicaoPedido.CZ02LOTE;
        this.biparEtiqueta();
      });
    },
    label: 'Alterar',
  };

  public readonly alterarURAction: PoModalAction = {
    action: () => {
      this.alterarURModal.close();
      this.romaneioService.postAlterarUR(this.etiquetaExpedicaoPedido.CZ02COD,this.etiquetaExpedicaoPedido.CZ02UR,this.etiquetaExpedicaoPedido.CZ02LOTE,this.etiquetaExpedicaoPedido.CB1COD,this.URselecionada).subscribe({
        next: (re) => {
          this.poNotificationService.success("UR alterado com sucesso!");
          this.etiquetalote = this.etiquetaExpedicaoPedido.CZ02LOTE;
          this.biparEtiqueta();
        }
      });
    },
    label: 'Alterar',
  };

}
